import { CircularProgress } from "@material-ui/core";

const CustomCircularProgress = () => {
	return <CircularProgress size={20} />;
};

export { CustomCircularProgress };
